import { observer } from 'mobx-react-lite'
import { InputCheckbox, Typography } from 'shared/ui'
import { LINK_CTIA_SHORT_CODE_HANDBOOK } from 'shared/constants/links'
import { PageDescription } from 'pages/settings/ui/PageDescription/PageDescription'
import { NextButton } from 'pages/settings/ui/NextButton/NextButton'
import { useRcsWizardContext } from 'pages/settings/pages/rcsV2/context/rcsWizardContext'

import styles from './styles.module.scss'

const TERMS_DISCLOSURES = [
  'Program name and description',
  'Message frequency',
  'Customer care instructions (e.g., Reply HELP for help)',
  'Opt-out instructions (e.g., Reply STOP to stop)',
  'Link to Privacy Policy',
  '"Message and data rates may apply" disclaimer',
  '"Carriers are not liable for delayed or undelivered messages" disclaimer',
]

export const Review = observer(() => {
  const {
    submit,
    saving,
    reviewStore: {
      agreePrivacy,
      agreeTerms,
      agreeCtia,
      isSubmitDisabled,
      toggleAgreePrivacy,
      toggleAgreeTerms,
      toggleAgreeCtia,
    },
  } = useRcsWizardContext()

  return (
    <div className={styles.wrap}>
      <PageDescription>
        Confirm that your messaging program meets carrier requirements before submitting.
      </PageDescription>

      <InputCheckbox
        className={styles.firstCheckbox}
        checked={agreePrivacy}
        onChecked={toggleAgreePrivacy}
        customLabel={
          <Typography
            ariaLabel='Review_privacy'
            variant='body-md-regular'
            color='var(--content-primary-tertiary)'
          >
            I confirm my Privacy Policy states that text messaging consent is not shared with third
            parties.
          </Typography>
        }
      />

      <InputCheckbox
        className={styles.checkbox}
        checked={agreeTerms}
        onChecked={toggleAgreeTerms}
        customLabel={
          <div className={styles.termsLabel}>
            <Typography
              ariaLabel='Review_terms'
              variant='body-md-regular'
              color='var(--content-primary-tertiary)'
            >
              I confirm my Terms of Service include all required disclosures:
            </Typography>
            <ul className={styles.disclosures}>
              {TERMS_DISCLOSURES.map((item) => (
                <li key={item}>
                  <Typography
                    className={styles.disclosureText}
                    tag='span'
                    ariaLabel='Review_disclosure'
                    variant='body-md-regular'
                    color='var(--content-primary-tertiary)'
                  >
                    {item}
                  </Typography>
                </li>
              ))}
            </ul>
          </div>
        }
      />

      <InputCheckbox
        className={styles.checkbox}
        checked={agreeCtia}
        onChecked={toggleAgreeCtia}
        customLabel={
          <Typography
            tag='span'
            ariaLabel='Review_ctia'
            variant='body-md-regular'
            color='var(--content-primary-tertiary)'
          >
            I have reviewed the&nbsp;
            <a
              className={styles.link}
              href={LINK_CTIA_SHORT_CODE_HANDBOOK}
              target='_blank'
              rel='noreferrer'
              onClick={(event) => event.stopPropagation()}
            >
              CTIA Short Code Compliance Handbook
            </a>
            &nbsp;and confirm this RCS Sender meets its requirements.
            <br />
            Carriers require Short Code–level compliance for RCS.
          </Typography>
        }
      />

      <NextButton
        text='Submit for review'
        disabled={isSubmitDisabled || saving}
        loading={saving}
        onClick={submit}
      />
    </div>
  )
})
